import { put, take } from 'redux-saga/effects'
import { ActionCreators as AuthenticationActionCreators } from 'src/redux/sagas/authentication'

export function* refreshApiCredentials() {
  yield put(AuthenticationActionCreators.SagaRefreshApiCredentials.create())
  yield take(AuthenticationActionCreators.SagaApiCredentialsRefreshUpdate.type)
}
